import { useCallback, useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';

const getPermissionValue = (permissions, path) => {
  return path.split('.').reduce((acc, key) => acc?.[key], permissions);
};

export default function useMiniPOSPermission() {
  const permissions = useSelector(state => state.auth?.shop?.miniposPermission?.setting ?? {}, shallowEqual);

  const can = useCallback(
    permission => {
      return getPermissionValue(permissions, permission) === true;
    },
    [permissions]
  );

  const cannot = useCallback(permission => !can(permission), [can]);

  const canAny = useCallback(
    permissionsList => {
      return permissionsList.some(can);
    },
    [can]
  );

  const canAll = useCallback(
    permissionsList => {
      return permissionsList.every(can);
    },
    [can]
  );

  return useMemo(
    () => ({
      permissions,

      can,
      cannot,

      canAny,
      canAll
    }),
    [permissions, can, cannot, canAny, canAll]
  );
}
